export const ProfileStatusConstants = {
    APPROVED: 'APPROVED',
    EMAIL_APPROVED: 'EMAIL_APPROVED',
    EMAIL_NOT_APPROVED: 'EMAIL_NOT_APPROVED',
    COMPANY_JOIN_REQUESTED: 'COMPANY_JOIN_REQUESTED'
};
